// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__2s2FM","content":"styles_content__1Pc6y"};